module.exports = __webpack_public_path__ + "static/media/darts.825d771c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/darts.svg
// module id = 372
// module chunks = 7